import { render } from "./IiifModal.vue?vue&type=template&id=761a6f8a&scoped=true"
import script from "./IiifModal.vue?vue&type=script&lang=js"
export * from "./IiifModal.vue?vue&type=script&lang=js"

import "./IiifModal.vue?vue&type=style&index=0&id=761a6f8a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761a6f8a"]])

export default __exports__